import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './incoterms.state';
import getters from './incoterms.getters';
import actions from './incoterms.actions';
import mutations from './incoterms.mutations';

BaseStore.registerModule('incoterms', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('incoterms');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};